import { SlackChannelSelector } from './SlackChannelSelector';
import { TextTemplateEditor } from './TextTemplateEditor';
import { SwitchEditor } from './SwitchEditor';
import { ScheduleEditor } from './ScheduleEditor';
import { DynamicSecretSelector } from './DynamicSecretSelector';
import { BuildListEditor } from './BuildListEditor';
import { DateTimeFormatEditor } from './DateTimeFormatEditor';
import { DurationFormatEditor } from './DurationFormatEditor';
import { CheckPasswordAlgorithmSelector, HashPasswordAlgorithmSelector } from './HashAlgorithmSelector';

// Registry mapping component IDs to their implementations
export const INTERFACE_COMPONENTS = {
    'slack-channel-selector': SlackChannelSelector,
    'text-template-editor': TextTemplateEditor,
    'switch-editor': SwitchEditor,
    'schedule-editor': ScheduleEditor,
    'dynamic-secret-selector': DynamicSecretSelector,
    'build-list-editor': BuildListEditor,
    'datetime-format-editor': DateTimeFormatEditor,
    'duration-format-editor': DurationFormatEditor,
    'check-password-algorithm': CheckPasswordAlgorithmSelector,
    'hash-password-algorithm': HashPasswordAlgorithmSelector,
} as const;

export type InterfaceComponentId = keyof typeof INTERFACE_COMPONENTS;

export const getInterfaceComponent = (componentId: string) => {
    return INTERFACE_COMPONENTS[componentId as InterfaceComponentId] || null;
};

// For lazy loading support (future enhancement)
export const getInterfaceComponentAsync = async (componentId: string) => {
    const component = getInterfaceComponent(componentId);
    return component ? Promise.resolve(component) : null;
};
